<template>
	<div class="page-user-lsit">
		<div class="pg-breadcrumb">
			<div class="breadcrumb-item em">派送專線</div>
			<div class="breadcrumb-item">派送大廈設定</div>
		</div>

		<div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
				<Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
				<div class="loading-text">Loading</div>
			</Spin>
			<div class="pg-toolbar">
				<div class="pg-btn-wrap">
					<span style="margin-right:10px;font-family: PingFang SC;font-weight: bold;">派送大廈設定列表</span>
					<div class="pg-btn" v-if="isBack" @click="handleBack()">返回</div>
					<div class="pg-btn style2" @click="handleToAdd">新增</div>
				</div>
			</div>
			<Table size="small"
			       no-data-text="暫無數據"
			       border
			       :columns="table.column"
			       :data="table.data">
				<template slot-scope="{ row, index }" slot="name">
					<Input size="small" v-model="row.name" style="width:80%"/>
				</template>

				<template slot-scope="{ row, index }" slot="sort">
					<div class="pg-btn-wrap">
						<InputNumber v-model="row.sort" style="width:80%" :min="0" :max="9999" />
					</div>
				</template>

				<template slot-scope="{ row, index }" slot="x">
					<div class="pg-btn-wrap">
						<Input size="small" v-model="row.x" style="width:80%"/>
					</div>
				</template>

				<template slot-scope="{ row, index }" slot="y">
					<div class="pg-btn-wrap">
						<Input size="small" v-model="row.y" style="width:80%"/>
					</div>
				</template>

				<template slot-scope="{ row, index }" slot="remark">
					<div class="pg-btn-wrap">
						<Input v-model="row.remark" maxlength="100" type="textarea" placeholder="備註" style="width: 90%" :rows="1" />
					</div>
				</template>

				<template slot-scope="{ row, index }" slot="settingtime">
					<div class="pg-btn-wrap">
						<div class="pg-btn" @click="handleFoward(row.id)">查看大廈時間段</div>
					</div>
				</template>

				<template slot-scope="{ row, index }" slot="maps">
					<div class="pg-btn-wrap">
						<div class="pg-btn style3" @click="handleModalMap_Setting(row)">地圖設置</div>
					</div>
				</template>

				<template slot-scope="{ row, index }" slot="status">
					<Switchs true-color="#51f4a9" v-model="row.status" @on-change="statusChange(row)"/>
				</template>

				<template slot-scope="{ row, index }" slot="action">
					<div class="pg-btn-wrap">
						<div class="pg-btn style1" @click="handleEdit(row)">修改</div>
						<div class="pg-btn" @click="handleDelete(row.id)">删除</div>
					</div>
				</template>
			</Table>

			<div class="pg-pagger">
				<Row>
					<Col span="11" class="pagger-left">
						<div class="pagger-total">總共{{totalCount}}條記錄</div>
					</Col>
					<Col span="13" class="pagger-right">
						<!-- v-if="totalCount > curPageSize" -->
						<div>
							<div class="pagger-sizer">
								<span>每頁</span>
								<Select v-model="curPageSize" size="small" placeholder="數量"
								        @on-change="handlePageSizeChange">
									<Option :value="10">10</Option>
									<Option :value="20">20</Option>
									<Option :value="30">30</Option>
									<Option :value="40">40</Option>
									<Option :value="50">50</Option>
								</Select>
							</div>

							<div class="pagger-elevator">
								<span>跳轉</span>
								<Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
								       @on-enter="handlePageEnter"/>
							</div>

							<Page size="small"
							      :current="pageIndex"
							      :page-size="curPageSize"
							      :total="totalCount"
							      @on-change="handlePageChange">
							</Page>
						</div>
					</Col>
				</Row>
			</div>

		</div>

		<div v-if="isShowAddModalMap">
			<Modal v-model="isShowAddModalMap"
			       fullscreen
			       title="地圖設置(新增)"
			       width="1200"
			       @on-ok="map_add_confirm()"
			       @on-cancel="handleModal_Add_Map_Cancel">
				<div class="modal-cont">
					<div class="pg-form-wrap">
						<div class="map-box">
							<!--<iframe style="width: 100%;height: calc(100vh - 92px)" src="https://jyb-admin-frontend.aoyunltd.com/maps/#/" frameborder="0"></iframe>-->
							<iframe style="width: 100%;height: calc(100vh - 150px)" src="map/index.html" frameborder="0"></iframe>
						</div>
					</div>
				</div>
			</Modal>
		</div>

		<div v-if="isShowModalMap">
			<Modal v-model="isShowModalMap"
			       fullscreen
			       title="地圖設置(修改)"
			       width="1200"
			       @on-ok="map_confirm(map_id)"
			       @on-cancel="handleModalMap_Cancel">
				<div class="modal-cont">
					<div class="pg-form-wrap">
						<div class="map-box">
							<!--<iframe style="width: 100%;height: calc(100vh - 92px)" src="https://jyb-admin-frontend.aoyunltd.com/maps/#/" frameborder="0"></iframe>-->
							<iframe style="width: 100%;height: calc(100vh - 150px)" src="map/index.html" frameborder="0"></iframe>
						</div>
					</div>
				</div>
			</Modal>
		</div>

		<Modal v-model="isShowModalSign_goods"
		       title="派送大廈設定列表 (新增)"
		       width="600"
		       :footer-hide="true"
		       @on-cancel="handleModalSignClose_goods">
			<div class="modal-cont">
				<Spin fix class="pg-sub-loading" v-if="isSubmitingLog">
					<div class="loading-text">Loading</div>
				</Spin>
				<div class="pg-form-wrap">
					<Row>
						<Col span="200" push="3">
							<Form :label-width="150">
								<Row>
									<Col span="16">
										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>專線名稱</span>
											</div>
											<Select placeholder="請選擇專線名稱" v-model="form.did">
												<Option :value="item.id" v-for="(item, index) in deliveryareaList"
												        :key="item.id">{{item.name}}
												</Option>
											</Select>
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>大廈名稱</span>
											</div>
											<Input v-model="form.address" placeholder="請填寫大廈名稱" clearable/>
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>詳細大廈地址</span>
											</div>
											<Input v-model="form.remark" maxlength="100" show-word-limit type="textarea" placeholder="請填寫詳細大廈地址" style="width: 100%" :rows="4" />
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>經度</span>
											</div>
											<Input v-model="form.x" placeholder="請填寫經度" clearable/>
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>緯度</span>
											</div>
											<Input v-model="form.y" placeholder="請填寫緯度" clearable/>
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>地圖設置</span>
											</div>
											<div class="pg-btn-wrap">
												<div class="pg-btn style2" @click="handleModal_Add_Map_Setting()">增加設置</div>
											</div>
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>狀態</span>
											</div>
											<Switchs true-color="#51f4a9" v-model="form.status_add"/>
										</FormItem>

										<FormItem>
											<div slot="label" class="form-label">
												<em class="red">* </em>
												<span>排序</span>
											</div>
											<InputNumber v-model="form.sort" :min="0" :max="9999" clearable />
										</FormItem>

										<FormItem>
											<div class="pg-btn-wrap">
												<div class="pg-btn style1" @click="handleCheckForm">確認添加</div>
											</div>
										</FormItem>
									</Col>
								</Row>
							</Form>
						</Col>
					</Row>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
   export default {
      data() {
         return {
            pageIndex: 1,   //页码
            curPageSize: 10,    //一页数量
            totalCount: 1, //总条数
            pageInput: '',  //输入的页码
            map_id: '',
            addLat: '',
            addLon: '',
            isShowModalSign_goods: false,
            isShowModalMap: false,
            isShowAddModalMap: false,
            isSubmitingLog: false,
            isSubmiting: false,
            isBack: false,
            deliveryareaList: [],
            form: {
               address: '',
               x: '',
               y: '',
               status: '',
               status_add: false,
               image: '',
               remark: '',
               sort: 1,
            },
            table: {
               column: [
                  {
                     title: '大廈名稱',
                     key: 'name',
                     slot: 'name',
                     align: 'center',
                     sortable: true,
                     width: 170
                  },
                  {
                     title: 'APP排序',
                     key: 'sort',
                     slot: 'sort',
                     align: 'center',
                     sortable: true,
                     width: 80
                  },
                  {
                     title: '詳細大廈地址',
                     key: 'remark',
                     slot: 'remark',
                     align: 'center',
                     sortable: true,
                     minWidth: 200
                  },
                  {
                     title: '大廈派送時間',
                     key: 'settingtime',
                     slot: 'settingtime',
                     align: 'center',
                     sortable: true,
                     width: 120
                  },
                  {
                     title: '經度設置',
                     key: 'x',
                     slot: 'x',
                     align: 'center',
                     sortable: true,
                     width: 120
                  },
                  {
                     title: '緯度設置',
                     key: 'y',
                     slot: 'y',
                     align: 'center',
                     sortable: true,
                     width: 120
                  },
                  {
                     title: '地圖設置',
                     key: 'maps',
                     slot: 'maps',
                     align: 'center',
                     sortable: true,
                     width: 120
                  },
                  // {
                  //     title: '操作人名稱',
                  //     key: 'last_admin_name',
                  //     align: 'center',
                  //     sortable: true,
                  //     minWidth: 40
                  // },
                  {
                     title: '是否開啟',
                     slot: 'status',
                     key: 'status',
                     align: 'center',
                     sortable: true,
                     width: 80
                  },
                  {
                     title: '操作',
                     slot: 'action',
                     align: 'center',
                     width: 130
                  }
               ],
               data: [],
            }
         };
      },
      created() {
         // let value = sessionStorage.getItem("positons");
         // console.log(value);
      },
      mounted() {
         this.pageParam = this.$route.query;
         if(this.pageParam.id == undefined || this.pageParam.id == "") {
            this.isBack = false;
            this.getDeliveryareaList();
            this.getList();
         }
         else {
            this.isBack = true;
            this.getDeliveryareaList(this.pageParam.id);
            this.getList(this.pageParam.id);
         }
      },
      activated() {
         this.pageParam = this.$route.query;
         if(this.pageParam.id == undefined || this.pageParam.id == "") {
            this.isBack = false;
            this.getDeliveryareaList();
            this.getList();
         }
         else {
            this.isBack = true;
            this.getDeliveryareaList(this.pageParam.id);
            this.getList(this.pageParam.id);
         }
      },
      methods: {
         handleBack() {
            this.$router.go(-1);
         },
         handleFoward(item)
         {
            this.$router.push({path: '/deliveryareabuildingtimeSetting?id=' + item});

         },
         getDeliveryareaList(item)
         {
            let api;
            if(item != null){
               api = this.$Api.deliveryareaList + '?id=' + item;
            }else{
               api = this.$Api.deliveryareaList;
            }
            this.$Rq.requestAuth({
               url: api,
               method: 'get'
            }).then((res) =>
            {
               if (res.code == 0)
               {
                  if(item != null){
                     this.form.did = res.data.data[0].id;
                  }
                  this.deliveryareaList = res.data.data;
               }
            });
         },
         statusChange(item) {
            let id = item.id;
            let status;
            if (item.status == true) {
               status = "1";
            }else {
               status = "0";
            }

            this.isSubmiting = true;

            this.$Rq.requestAuth({
               url: this.$Api.deliveryareaAddressEdit + "\/" + id + '\/edit',
               method: 'post',
               data: {
                  id: id,
                  status: status,
               }
            }).then((res) =>
            {
               this.isSubmiting = false;

               if (res.code == 0)
               {
                  this.$Utils.showSuccess(res.msg);
                  if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                  }
                  else {
                     this.getList(this.pageParam.id);
                  }
               } else
               {
                  this.$Utils.showTipInfo(res.msg);
                  if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                  }
                  else {
                     this.getList(this.pageParam.id);
                  }
               }
            }).catch((err) =>
            {
               this.isSubmiting = false;
            });
         },

         getList(item) {
            let form = this.form;
            this.isSubmiting = true;

            let api;
            if(item != null){
               api = this.$Api.deliveryareaAddressList + '?d_id=' + item;
            }else{
               api = this.$Api.deliveryareaAddressList;
            }

            this.$Rq.requestAuth({
               url: api,
               method: 'get',
               data: {
                  offset: (this.pageIndex - 1) * this.curPageSize,
                  limit: this.curPageSize,
               }
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 0) {
                  let tempArr = [];
                  let resData = res.data.data;
                  for (let i = 0; i < resData.length; i++) {

                     if(resData[i].status == "1"){
                        resData[i].status = true;
                     }
                     else {
                        resData[i].status = false;
                     }

                     tempArr.push({
                        id: resData[i].id,
                        did: resData[i].did,
                        name: resData[i].name,
                        x: resData[i].x,
                        y: resData[i].y,
                        sort: resData[i].sort,
                        status: resData[i].status,
                        remark: resData[i].remark,
                        last_admin_name: resData[i].last_admin_name,
                        delivery_time: resData[i].delivery_time == null ? '---' : resData[i].delivery_time,
                     });
                  }
                  this.totalCount = res.data.count;
                  this.table.data = tempArr;
               } else {
                  this.showTipInfo(res.msg);
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },
         handleCheckForm() {

            let form = this.form;

            if (form.address === '') {
               this.$Utils.showTipInfo('請輸入地址名稱');
               return;
            } else if (form.x === '') {
               this.$Utils.showTipInfo('請輸入經度');
               return;
            } else if (form.y === '') {
               this.$Utils.showTipInfo('請輸入緯度');
               return;
            } else if (form.status_add === '') {
               this.$Utils.showTipInfo('請輸入狀態');
               return;
            } else if (form.did === '') {
               this.$Utils.showTipInfo('請輸入關聯專線ID');
               return;
            } else if (form.sort === '') {
               this.$Utils.showTipInfo('請輸入排序');
               return;
            } else if (form.remark === '') {
               this.$Utils.showTipInfo('請輸入備註');
               return;
            }
            this.handleSubmit();
         },
         handleModalSignClose_goods(){
            this.isShowModalSign_goods = false;
         },
         handleModalMap_Cancel(){
            this.isShowModalMap = false;
         },
         handleModalMap_Setting(item) {
            this.map_id = item.id;
            sessionStorage.setItem('initLocation',JSON.stringify([item.x,item.y]))
            this.isShowModalMap = true;
         },
         handleModal_Add_Map_Cancel(){
            this.isShowAddModalMap = false;
         },
         handleModal_Add_Map_Setting() {
            this.isShowAddModalMap = true;
         },
         map_confirm(map_id) {
            let positons = JSON.parse(sessionStorage.getItem('positons'));
            console.log(positons)
            this.$Rq.requestAuth({
               url: this.$Api.deliveryareaAddressEdit + "\/" + map_id + '\/edit',
               method: 'post',
               data: {
                  y: positons.longitude,
                  x: positons.latitude,
                  remark: positons.address,
               }
            }).then((res) =>
            {
               if (res.code == 0)
               {
                  this.$Utils.showSuccess(res.msg);
                  this.handleModalMap_Cancel();
                  if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                  }
                  else {
                     this.getList(this.pageParam.id);
                  }
               } else
               {
                  this.$Utils.showTipInfo(res.msg);
                  if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                  }
                  else {
                     this.getList(this.pageParam.id);
                  }
               }
            }).catch((err) =>
            {
               // this.isSubmiting = false;
            });
         },

         map_add_confirm() {
            let positons = JSON.parse(sessionStorage.getItem('positons'));
            this.form.x = positons.longitude;
            this.form.y = positons.latitude;
            this.form.remark = positons.address;
         },

         handleSubmit() {
            let form = this.form;
            let status_id;
            let did;
            this.isSubmiting = true;

            if(form.status_add == true){
               status_id = "1";
            }

            if(form.status_add == false){
               status_id = 0;
            }

            if(this.pageParam.id == undefined || this.pageParam.id == ""){
               did = '';
            }
            else{
               did = this.pageParam.id;
            }

            this.$Rq.requestAuth({
               url: this.$Api.deliveryareaAddressAdd_new,
               method: 'post',
               data: {
                  address: form.address,
                  x: form.x,
                  y: form.y,
                  status: status_id,
                  did: form.did,
                  sort: form.sort,
                  remark: form.remark
               }
            }).then((res) => {
               this.isSubmiting = false;
               if (res.code == 0) {
                  this.$Utils.showSuccess(res.msg);
                  this.form = {
                     did: did,
                     address: '',
                     x: '',
                     y: '',
                     status_add: false,
                     remark: '',
                     sort: '',
                  };
                  this.handleModalSignClose_goods();
                  if(this.pageParam.id == undefined || this.pageParam.id == "") {
                     this.getList();
                     this.getDeliveryareaList();
                  }
                  else {
                     this.getList(this.pageParam.id);
                     this.getDeliveryareaList(this.pageParam.id);
                  }
               } else {
                  this.$Utils.showTipInfo(res.msg);
               }
            }).catch((err) => {
               this.isSubmiting = false;
            });
         },
         handleToAdd() {
            this.isShowModalSign_goods = true;
            this.form.sort = this.totalCount + 1;
         },
         handleEdit(item) {
            this.$Modal.confirm({
               title: '修改提示',
               content: '確定修改嗎？',
               cancelText: '取消',
               okText: '確定',
               onOk: () => {
                  let id = item.id;
                  let address = item.name;
                  let x = item.x;
                  let y = item.y;
                  let sort = item.sort;
                  let image = item.image;
                  let remark = item.remark;

                  this.isSubmiting = true;
                  this.$Rq.requestAuth({
                     url: this.$Api.deliveryareaAddressEdit + "\/" + id + '\/edit',
                     method: 'post',
                     data: {
                        x: x,
                        y: y,
                        sort: sort,
                        image: image,
                        remark: remark,
                        address: address,
                     }
                  }).then((res) =>
                  {
                     this.isSubmiting = false;

                     if (res.code == 0)
                     {
                        this.$Utils.showSuccess(res.msg);
                        if(this.pageParam.id == undefined || this.pageParam.id == "") {
                           this.getList();
                        }
                        else {
                           this.getList(this.pageParam.id);
                        }
                     } else
                     {
                        this.$Utils.showTipInfo(res.msg);
                        if(this.pageParam.id == undefined || this.pageParam.id == "") {
                           this.getList();
                        }
                        else {
                           this.getList(this.pageParam.id);
                        }
                     }
                  }).catch((err) =>
                  {
                     this.isSubmiting = false;
                  });
               }
            });
         },
         handleDelete(index) {
            this.$Modal.confirm({
               title: '刪除提示',
               content: '確定刪除嗎？',
               cancelText: '取消',
               okText: '確定',
               onOk: () => {
                  let tableData = this.table.data;
                  this.isSubmiting = true;

                  this.$Rq.requestAuth({
                     url: this.$Api.deliveryareaAddressDelete + "\/" + index + '\/del',
                     method: 'post',
                  }).then((res) => {
                     this.isSubmiting = false;
                     if (res.code == 0) {
                        this.$Utils.showSuccess(res.msg);
                        if(this.pageParam.id == undefined || this.pageParam.id == "") {
                           this.getList();
                        }
                        else {
                           this.getList(this.pageParam.id);
                        }
                     } else {
                        this.$Utils.showTipInfo(res.msg);
                     }
                  }).catch((err) => {
                     this.isSubmiting = false;
                  });
               }
            });
         },
         handlePageSizeChange(value)
         {
            this.pageIndex = 1;
            if(this.pageParam.id == undefined || this.pageParam.id == "") {
               this.getList();
            }
            else {
               this.getList(this.pageParam.id);
            }
         },
         handlePageInput()
         {
            let value = ('' + this.pageInput).replace(/\D/g, '');
            let pageCount = Math.ceil(this.totalCount / this.curPageSize);
            if (value > pageCount)
            {
               value = pageCount;
            }
            this.pageInput = value;
         },
         handlePageEnter()
         {
            if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
            if (this.pageInput == 0)
            {
               this.pageInput = 1;
            }
            this.pageInput = parseInt(this.pageInput);
            this.pageIndex = this.pageInput;
            if(this.pageParam.id == undefined || this.pageParam.id == "") {
               this.getList();
            }
            else {
               this.getList(this.pageParam.id);
            }
         },
         handlePageChange(value)
         {
            this.pageIndex = value;
            if(this.pageParam.id == undefined || this.pageParam.id == "") {
               this.getList();
            }
            else {
               this.getList(this.pageParam.id);
            }
         }
      }
   };
</script>

<style lang="scss" scoped>
	@import 'deliveryareaaddressSetting.scss';
</style>
